import React from 'react';

export default React.createContext(null);



// WEBPACK FOOTER //
// ./src/components/FreactalStoreContext.js